import React from "react"
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap"
import observabilityService, { LOG_SEVERITY } from "../../services/observability_service"

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = { hasError: false, error: null }
    }

    static getDerivedStateFromError(error) {
        // Atualiza o estado para que a próxima renderização mostre a UI de fallback.
        return { hasError: true, error }
    }

    componentDidCatch(error, errorInfo) {
        // Você também pode registrar o erro em um serviço de relatório de erros
        observabilityService.logError(error, {
            severity: LOG_SEVERITY.CRITICAL,
            componentStack: errorInfo.componentStack,
            location: window.location.href,
        })
    }

    handleRestart = () => {
        window.location.href = "/"
    }

    render() {
        if (this.state.hasError) {
            // Você pode renderizar qualquer UI de fallback personalizada
            return (
                <div className="account-pages my-5 pt-5">
                    <Container>
                        <Row className="justify-content-center">
                            <Col md={8} lg={6} xl={5}>
                                <Card className="overflow-hidden">
                                    <CardBody className="pt-0">
                                        <div className="p-2 text-center">
                                            <div className="avatar-md mx-auto d-block mb-4">
                                                <span className="avatar-title rounded-circle bg-danger bg-soft text-danger display-4">
                                                    <i className="mdi mdi-alert-circle-outline"></i>
                                                </span>
                                            </div>
                                            <h4 className="text-uppercase fw-bold">Ops! Algo deu errado.</h4>
                                            <p className="text-muted mb-4">
                                                Ocorreu um erro inesperado na aplicação. O administrador já foi notificado.
                                            </p>
                                            <Button
                                                color="primary"
                                                className="btn btn-primary waves-effect waves-light"
                                                onClick={this.handleRestart}
                                            >
                                                Voltar para o Início
                                            </Button>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            )
        }

        return this.props.children
    }
}

export default ErrorBoundary
